<template>
  <div class="px-2 badge badge-pill" :class="[pillType]">
    {{ content }}
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";

export default {
  name: "Pill",
  props: {
    variant: {
      type: String,
      default: "primary",
    },
    content: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const typeList = {
      primary: "badge-primary",
      secondary: "badge-secondary",
      success: "badge-success",
      danger: "badge-danger",
      warning: "badge-warning",
      info: "badge-info",
      light: "badge-light",
      dark: "badge-dark",
    };
    const pillType = computed(() => {
      return typeList[props.variant];
    });
    return {
      pillType,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.badge-pill {
  max-height: 1rem;
  min-height: 1rem;
  font-size: 11px;
}
</style>
